import { IconContent } from '@icons';

export const errorCircleFilled: IconContent = {
    sm: '<path d="M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0Z" /><path d="M8.62 4v5H7.37V4h1.25ZM8 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="#fff"/>',
};
